import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../pages/listings.module.css';
import { truncate } from '../../utils/utils';

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleString('en-UK', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : '';

const SupplierTable = ({ suppliers }) => {
  const navigate = useNavigate();

  return (
    <table className='table table-striped table-hover'>
      <thead>
        <tr className={styles.headings}>
          <th scope='col'>#</th>
          <th scope='col'>Name</th>
          <th scope='col'>DG</th>
          <th scope='col'>Country</th>
          <th scope='col'>City</th>
          <th scope='col'>Contact</th>
          <th scope='col'>Email</th>
          <th scope='col'>Updated At</th>
        </tr>
      </thead>
      <tbody>
        {suppliers.length > 0 ? (
          suppliers.map((supplier, index) => (
            <tr
              key={supplier.id}
              className={styles.rows}
              onClick={() => navigate(`/quantila/supplier/${supplier.id}`)}
            >
              <th scope='row'>{index + 1}</th>
              <td>{truncate(supplier.name, 30)}</td>
              <td>{supplier.dg}</td>
              <td>{supplier.country}</td>
              <td>{supplier.city}</td>
              <td>{supplier.contact}</td>
              <td>{supplier.email}</td>
              <td>{formatDate(supplier.updatedAt)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={8}>No suppliers to display ...</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default SupplierTable;
